import React, { useEffect, useRef, useState, useOnMount } from "react";
import { Link, useLocation } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { currentUserInfo } from "../../atoms/signInAtom";
import { notificationMsgsState } from "../../atoms/notificationAtom";

/* Stylesheet */

import "./styles.scss";

/* Icon */
import Logo from "../../widgets/Logo";
import defaultUser from "../../assets/images/default-user.png";
import bellIconImg from "../../assets/images/bell-icon.svg";
import bgHeader from "../../assets/images/bg-header.png";

/* Components */

import NotificationDropDown from "../NotificationDropDown/index";
import ProfileIconDropDown from "../ProfileIconDropDown/index";
import { useTranslation } from "react-i18next";

window.dataExp = window.dataExp || {};

const Header = () => {
  const userInfo = useRecoilValue(currentUserInfo);
  const notificationRef = useRef();
  const profileIconRef = useRef();
  const location = useLocation();
  const [role, setRole] = useState(null);

  const { t: tProfile } = useTranslation(["profile"]);

  const [showNotification, setShowNotification] = useState(false);
  const [showProfileDropDown, setShowProfileDropDown] = useState(false);

  useEffect(() => {
    if (userInfo && userInfo.user) {
      setRole(userInfo.user.user_type === "client" ? "customer" : "caregiver");
    }
  }, [userInfo]);

  useEffect(() => {
    const handleNotification = (e) => {
      if (showNotification && notificationRef.current && !notificationRef.current.contains(e.target)) {
        setShowNotification(!showNotification);
      }
    };
    const handleProfileDropDown = (e) => {
      if (showProfileDropDown && profileIconRef.current && !profileIconRef.current.contains(e.target)) {
        setShowProfileDropDown(!showProfileDropDown);
      }
    };
    document.addEventListener("mousedown", handleNotification);
    document.addEventListener("mousedown", handleProfileDropDown);
    return () => {
      document.removeEventListener("mousedown", handleNotification);
      document.removeEventListener("mousedown", handleProfileDropDown);
    };
  }, [showNotification, showProfileDropDown]);

  /** START: WebSocket data receive**/
  const [notificationMsgs, setNotificationMsgs] = useRecoilState(notificationMsgsState);

  useEffect(() => {
    window.dataExp = notificationMsgs;
  } ,[]);


  const ws = useRef(null);

  useEffect(() => {
    if(userInfo && userInfo.accessToken) {
    const host = window.location.hostname === "localhost" ? "ws://localhost:8000" : "wss://chc.stage.nixa.ca";
    ws.current = new WebSocket(`${host}/api/notifications/?token=${userInfo.accessToken}`);

    ws.current.onmessage = (event) => {

      const jsonData = JSON.parse(event.data);

      if(jsonData.notifications) {
           // Is multiple notifications.
        const j = {notifications: []};
        jsonData.notifications.map((elem) => {
          j.notifications.push(elem);
        });
        setNotificationMsgs(j);
        window.dataExp = j;

      } else if (jsonData.data){
        // Is single notification.
        const j = {notifications: []};
        window.dataExp.notifications.map((elem) => {
          j.notifications.push(elem);
        });
        j.notifications.push(jsonData.data);
        setNotificationMsgs(j);
        window.dataExp = j;

      }
    };
    return () => ws.current.close();
  }
  }, [userInfo]);


  const sendMsgNotify = (notificationId) => {
    if(ws) {
      ws.current.send(JSON.stringify({ notification_id: notificationId, status: "read" }));
    }
  };

  /** END: WebSocket data receive**/

  return (
    <div className={"profile-header"}>
      <div className={"top-icons"}>
        <div className={"left-icons"}>
          <Link to={"/"} className={"logo-link"}>
            <Logo />
          </Link>
        </div>
        <div className={"right-icons"}>
          <div>
            <button className={"bell-button"} onClick={() => setShowNotification(!showNotification)}>
              <div className={"bell-icon-wrap"}>
                <img className={"bell-img"} src={bellIconImg} alt="Bell Image" />
              </div>

              <div className={"bell-icon-dropdown"}>{showNotification && <NotificationDropDown notificationRef={notificationRef} sendMsgNotify={sendMsgNotify} />}</div>
            </button>
            <span className={"bell-badge"}>{notificationMsgs?.notifications?.length}</span>
          </div>

          <button className={"profile-icon"} onClick={() => setShowProfileDropDown(!showProfileDropDown)}>
            <img className={"profile-img"} src={userInfo && userInfo?.profile?.profile_picture ? userInfo?.profile?.profile_picture : defaultUser} alt="Profile Image" />
            <div className={"profile-icon-dropdown"}>
              {showProfileDropDown && role && (
                <div>
                  <ProfileIconDropDown profileIconRef={profileIconRef} role={role} />
                </div>
              )}
            </div>
          </button>
        </div>
      </div>
      <div
        className={"deco-stripe"}
        style={{
          // backgroundImage: `url(${bgHeader})`,
        }}
      ></div>
      <div className={"bottom-icons"}>
        {role && (
          <Link
            to={role === "customer" ? "/customer/profile" : "/caregiver/profile"}
            className={`bottom-icon-link ${
              (location.pathname === "/customer/profile" && "bottom-icon-link--highlighted") || (location.pathname === "/caregiver/profile" && "bottom-icon-link--highlighted")
            }`}
          >
            {tProfile("Profile")}
          </Link>
        )}

        {role && (
          <>
            <Link
              to={role === "customer" ? "/customer/visits" : "/caregiver/shifts"}
              className={`bottom-icon-link ${
                (location.pathname === "/customer/visits" && "bottom-icon-link--highlighted") ||
                (location.pathname === "/customer/visits/appointments" && "bottom-icon-link--highlighted") ||
                (location.pathname === "/customer/visits/request" && "bottom-icon-link--highlighted") ||
                (location.pathname === "/caregiver/shifts" && "bottom-icon-link--highlighted") ||
                (location.pathname === "/caregiver/shifts/availability" && "bottom-icon-link--highlighted") ||
                (location.pathname === "/caregiver/shifts/requests" && "bottom-icon-link--highlighted") ||
                (location.pathname.includes("/customer/visits/appointment/details/") && "bottom-icon-link--highlighted")
              }
          `}
            >
              {role === "customer" ? tProfile("Visits") : tProfile("Shifts")}
            </Link>
            <Link to={`/${role}/files`} className={`bottom-icon-link ${location.pathname === `/${role}/files` && "bottom-icon-link--highlighted"}`}>
              {tProfile("Files")}
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default Header;
